import type { ProductoEntregaOption } from './models/EntregaCatalog.ts';

export type EntregaTotales = {
  paquetesEntregados: number;
  capacitados: number;
  bolsasReutilizables: number;
};

export type EntregaTotalesParticipante = {
  productoPublicIds: string[];
  encuentroEducativo: 'si' | 'no' | 'no_aplica';
  entregaBolsa: 'si' | 'no';
};

export function computeEntregaTotales(
  participantes: EntregaTotalesParticipante[],
  _productos: ProductoEntregaOption[],
): EntregaTotales {
  let capacitados = 0;
  let bolsasReutilizables = 0;
  for (const row of participantes) {
    if (row.entregaBolsa === 'si') bolsasReutilizables += 1;
    if (row.encuentroEducativo === 'si') capacitados += 1;
  }
  return { paquetesEntregados: participantes.length, capacitados, bolsasReutilizables };
}

export function computeRemanente(solicitadas: number, entregadas: number): number {
  return Math.max(0, solicitadas - entregadas);
}
